import {
  useConfirmationDialog,
  usePrinterHooks
} from '@justomx/atlas-components'
import { useEffect, useState } from 'react'
import { useLoaderData } from 'react-router-dom'

import { Analytics } from 'analytics/analytics.events'
import { getTransferByContainer } from 'client/stock-transfers/stock-transfers.client'
import { type TransferData, TransferPageSchema } from 'types/commons/model'
import { ZOD_ERROR } from 'utils/constants'
import { useGoToPreparation } from './preparation/Preparation.navigator'
import { useGoToScanPrinter } from './scan-printer/ScanPrinter.navigator'
import { useGoToTransfer } from './transfer/Transfer.navigator'
import { useGoToTransferDetail } from './transfer-detail/TransferDetail.navigator'

export const useAssembly = () => {
  const transferDetail = useGoToTransferDetail()
  const preparation = useGoToPreparation()
  const transfer = useGoToTransfer()
  const scanPrinter = useGoToScanPrinter()
  const { open, dialogRef } = useConfirmationDialog()
  const { isConfigured } = usePrinterHooks()
  const transfersRaw = useLoaderData()
  const [loading, setLoading] = useState(false)
  const [printerReady, setPrinterReady] = useState(false)

  useEffect(() => {
    isConfigured().then((configured) => {
      setPrinterReady(configured)
    })
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  const result = TransferPageSchema.safeParse(transfersRaw)
  if (!result.success) {
    console.info(result.error)
    throw Error(ZOD_ERROR)
  }
  const transfers: TransferData[] = result.data.data

  const handleScanPallet = async (scanned: string) => {
    try {
      setLoading(true)
      const response = await getTransferByContainer(scanned)
      transferDetail.go(response.transferId, response.docNum, scanned)
    } catch (error) {
      console.error(error)
    } finally {
      setLoading(false)
    }
  }

  const handleClickTransfer = (
    transferId: string,
    docNum: string,
    status: string,
    toWarehouse: string
  ) => {
    const actionByStatus = {
      pending: () => transferDetail.go(transferId, docNum),
      inProgress: () => transferDetail.go(transferId, docNum),
      readyToWrap: () => preparation.go(transferId, docNum),
      readyForLoading: () => transfer.go(transferId, docNum)
    }[status]

    if (actionByStatus) {
      Analytics.assembly.selectOrder({
        transferId,
        docNum,
        status,
        toWarehouse
      })
      actionByStatus()
    }
  }

  const handleClickKeyboard = () => {
    open()
  }

  const onClickPrinter = () => {
    if (printerReady) {
      return
    }

    scanPrinter.go('a', 'b')
  }

  return {
    dialogRef,
    transfers,
    loading,
    printerReady,
    actions: {
      handleScanPallet,
      handleClickTransfer,
      handleClickKeyboard,
      onClickPrinter
    }
  }
}
